import React, { useState, useEffect } from "react";
import * as Sentry from "@sentry/react";
// Styling converted to TailwindCSS — removed modular CSS import
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../store/actions/loginActions";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Fade from "@material-ui/core/Fade";
import ModalComponent from "../../components/Modals/Modal";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";

// import { GoogleLogin, GoogleLogout } from "react-google-login";
// import FacebookLogin from "react-facebook-login";
// import AppleLogin from "react-apple-login";

function WemoovezLogin() {
  // state to display errors
  const [error, seterror] = useState("");
  //history for routing
  const history = useNavigate();
  // dispatch actions
  const dispatch = useDispatch();
  // login with fb clicked
  const componentClicked = (data) => {
    console.log("fb login component clicked", data);
  };
  // facebook login
  const responseFacebook = (response) => {
    console.log("login", response);
  };
  //   google login
  const responseGoogle = (response) => {
    if (response.accessToken !== null) {
      alert("Login success");
    } else {
      seterror("Login with google Failed");
      console.log(response);
    }
  };

  //loader
  const [loader, setLoader] = useState(false);
  //getting login error

  const [loginErr, setloginErr] = useState(false);
  // getting error and auth state
  const { loginError, loginInfo } = useSelector((state) => state.loginReducer);
  // email
  const [email, setemail] = useState("");
  // password
  const [password, setpassword] = useState("");
  // show password toggle
  const [showPassword, setShowPassword] = useState("password");
  // terms and conditions
  const [TnC, setTnC] = useState(false);
  const [modalFields, setModalFields] = useState({
    open: false,
    text: "",
    btnText1: "Ok",
    closeFunc: () => {
      setModalFields({ ...modalFields, open: false });
    },
  });

  // Function to update tripStatus in VBO localStorage
  function updateTripStatus(newStatus = "ContactInfo") {
    // Get current VBO from localStorage
    const vboString = localStorage.getItem("VBO");
    // if (!vboString) return; // Exit if VBO not found

    try {
      const vbo = JSON.parse(vboString);

      // Update only if current tripStatus is "PersonalInfo"
      if (vbo.tripStatus === "PersonalInfo") {
        vbo.tripStatus = newStatus;

        // Save back to localStorage
        localStorage.setItem("VBO", JSON.stringify(vbo));
      }
    } catch (error) {
      console.error("Failed to update tripStatus in VBO:", error);
    }
  }

  // Sync booking flow only after successful login so PersonalInfo is skipped
  useEffect(() => {
    if (loginInfo && loginInfo.id) {
      updateTripStatus();
    }
  }, [loginInfo]);

  // useEffect to show error modal
  useEffect(() => {
    try {
      if (error) {
        setModalFields({
          ...modalFields,
          open: true,
          text: error,
        });
        seterror("");
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [error]);

  // Sign In
  const handleLogin = () => {
    try {
      if (email && password) {
        setLoader(true);
        const loginData = {
          email: email,
          password: password,
        };
        // console.log("login data from signup component", loginData);
        dispatch(login(loginData, seterror, history, setLoader));
      } else {
        setModalFields({
          ...modalFields,
          open: true,
          text: "Please fill all the fields!",
        });
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };
  const toggleShowPassword = () => {
    if (showPassword === "text") setShowPassword("password");
    else setShowPassword("text");
  };
  return (
    <div
      className="flex items-start justify-center px-4 w-full pt-6"
      style={{ minHeight: "calc(100vh - 60px)" }}
    >
      <ModalComponent
        text={modalFields.text}
        openState={modalFields.open}
        closeFunction={() => {
          setModalFields({ ...modalFields, open: false });
        }}
        btnText1={modalFields.btnText1}
        btnClickFunc1={modalFields.closeFunc}
      />
      <div className="w-full max-w-container mx-auto">
        <div className="flex flex-col items-start gap-1 mb-6">
          <h1 className="text-[#211F59] text-2xl font-semibold">Welcome back to moovez!</h1>
          <p className="text-[#211F59] text-sm font-semibold">Let’s get your stuff moved.</p>
        </div>

        <div className="space-y-4">
          <input
            value={email}
            placeholder="Email address"
            onChange={(e) => setemail(e.target.value)}
            className="w-full bg-[#E6E6E6] placeholder-[#89839B] text-[#373559] px-[13.5px] h-[48px] rounded-[12px] text-sm outline-none border-[1px] border-transparent focus:border-[#7876A1]"
          />

          <div className="relative">
            <input
              value={password}
              type={showPassword}
              placeholder="Password"
              className="w-full bg-[#E6E6E6] placeholder-[#89839B] text-[#373559] pl-[13.5px] pr-12 h-[48px] rounded-[12px] text-sm outline-none border-[1px] border-transparent focus:border-[#7876A1]"
              onChange={(e) => setpassword(e?.target?.value)}
            />
            <button
              onClick={() => toggleShowPassword()}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#5B5472]"
              aria-label="toggle password visibility"
              type="button"
            >
              {showPassword === "password" ? (
                <BsFillEyeFill size={18} />
              ) : (
                <BsFillEyeSlashFill size={18} />
              )}
            </button>
          </div>

          {loginErr ? (
            <div>
              <Fade in={loginErr === true} timeout={1000}>
                <p className="text-sm text-red-500">Login failed, please try again.</p>
              </Fade>
            </div>
          ) : null}

          <div className="flex items-center gap-3">
            <label className="inline-flex items-center space-x-2">
              <input
                type="checkbox"
                checked={TnC}
                onChange={(e) => setTnC(e.target.checked)}
                className="w-3 h-3 accent-[#211F59]"
              />
              <span className="text-[#211F59] text-[12px]">Keep me signed in</span>
            </label>

            <div className="ml-auto text-[12px] text-[#7876A1] underline font-semibold cursor-pointer" onClick={() => history("/forgotPassword")}>Forgot password?</div>
          </div>

          {/* Loader is shown inside the login button while API is in progress */}

          <div className="flex flex-col gap-3">
            <button
              className="w-full mt-[18px] bg-[#34318C] text-white rounded-[15px] px-8 h-[48px] text-sm font-medium hover:opacity-95 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center"
              onClick={() => {
                handleLogin();
              }}
              disabled={loader}
              aria-busy={loader}
            >
              {loader ? (
                <Box sx={{ display: "flex" }}>
                  <CircularProgress size={18} color="inherit" />
                </Box>
              ) : (
                "Log in"
              )}
            </button>

            <div className="text-center w-full text-[12px] text-[#211F59] mt-[3px]">
              Don't have an account?{' '}
              <span className="text-[#211F59] font-bold cursor-pointer underline" onClick={() => history('/Signup')}>Sign up</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WemoovezLogin;
